import { CheckSquare, AlertOctagon, CalendarClock, Wrench } from "lucide-react";
import { cn } from "@/lib/utils";
import { SectionLabel } from "@/components/common/ui-kit";
import { STATUS, SURFACE, TYPE } from "@/design/tokens";

const TILES = [
  { key: "todo", label: "Attività da fare", icon: CheckSquare, tone: "neutral" },
  { key: "overdue", label: "Attività scadute", icon: AlertOctagon, tone: "red" },
  { key: "appointments", label: "Appuntamenti", icon: CalendarClock, tone: "blue" },
  { key: "interventions", label: "Interventi oggi", icon: Wrench, tone: "amber" },
];

const Tile = ({ tile, value, index }) => {
  const Icon = tile.icon;
  const alert = tile.key === "overdue" && value > 0;
  return (
    <div className={cn("animate-rise p-5 transition-colors hover:bg-slate-50/70", `delay-${index + 1}`)} data-testid={`today-tile-${tile.key}`}>
      <div className="flex items-center justify-between">
        <p className="text-xs font-medium text-slate-500">{tile.label}</p>
        <span className={cn("flex h-8 w-8 items-center justify-center rounded-lg", STATUS[tile.tone].icon)}><Icon className="h-4 w-4" /></span>
      </div>
      <p className={cn("mt-3", TYPE.metric, alert && STATUS.red.text)}
        data-testid={`today-value-${tile.key}`}>{value}</p>
    </div>
  );
};

export const TodayStrip = ({ today }) => {
  const tiles = TILES.filter((t) => today[t.key] !== undefined);
  return (
    <section data-testid="dashboard-section-oggi">
      <SectionLabel className="mb-3">Oggi</SectionLabel>
      <div className={cn("grid grid-cols-2 divide-line overflow-hidden lg:grid-cols-4 lg:divide-x [&>*:nth-child(-n+2)]:border-b [&>*:nth-child(-n+2)]:border-line lg:[&>*]:border-b-0 [&>*:nth-child(odd)]:border-r [&>*:nth-child(odd)]:border-line lg:[&>*]:border-r-0", SURFACE.card)}>
        {tiles.map((t, i) => <Tile key={t.key} tile={t} value={today[t.key]} index={i} />)}
      </div>
    </section>
  );
};
